import React, { useState, useContext, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import Cookies from "js-cookie";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Alert } from "../../shared";
import avatar from "../../assets/images/plant.svg";
import ShortcutModal from "../ShortcutModal";
import { UsersDevice, Users, AllUsers, HomeEdit } from "./";
import { ProfileSection } from "../../context/ProfileContext";
import {
  invitationNewApi,
  deviceMineApi,
  dashboardZone,
  zoneWidgets,
} from "../../api";
import {
  setNewInvitation,
  setDeviceMine,
  setDashboardZone,
  setDashboardDetails,
  setZoneWidgets,
} from "../../redux";
import { withRouter } from "react-router-dom";
import { DeviceMineContext } from "../../context/DeviceMineContext";
import { useTranslation } from "react-i18next";
import { FiHome, FiCpu, FiEdit2, FiSettings, FiUsers, FiPlus, FiTrash2, FiChevronDown, FiChevronUp } from "react-icons/fi";

const ProfileFirstPageComp = (x) => {
  const { t } = useTranslation();
  const { props, props22 } = x;
  console.log(props22);
  const { deviceMine } = useContext(DeviceMineContext);
  const dispatch = useDispatch();
  const token = Cookies.get("token");
  const form = useRef();
  const [openAddUser, setOpenAddUser] = useState(false);
  const { ProfileShowHideFunc } = useContext(ProfileSection);
  const [showDashboard, setShowDashboard] = useState(false);
  const [showHomeEdit, setShowHomeEdit] = useState(false);
  const userInfo = useSelector((state) => state.userProfileInfo);
  const invitationList = useSelector(
    (state) => state.invitationList.invitationList
  );
  const dashboardMine = useSelector(
    (state) => state.dashboardMine.dashboardMine
  );
  let [activeIndex, setActiveIndex] = useState(0);
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
    question: false,
    id: "",
    request: "",
  });
  const toggleAlert = () => {
    setShowAlert((prevState) => ({
      ...prevState,
      show: false,
    }));
  };
  const initialValues = {
    name: "",
    email: "",
  };

  const submitForm = () => {
    const data = new FormData(form.current);
    invitationNewApi(data, token)
      .then((res) => {
        dispatch(setNewInvitation(res.data.data));
        setOpenAddUser(!openAddUser);
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
          setShowAlert((prevState) => ({
            ...prevState,
            show: true,
            message: t("خطایی رخ داده است . لطفا مجددا امتحان کنید."),
            type: "Error",
          }));
          setTimeout(() => {
            setShowAlert((prevState) => ({
              ...prevState,
              show: false,
            }));
          }, 2000);
        }
      });
  };

  const validationSchema = Yup.object({
    name: Yup.string().required(t("نام را وارد کنید.")),
    email: Yup.string()
      .required(t("ایمیل را وارد کنید"))
      .email(t("ایمیل را طبق فرمت وارد کنید")),
  });

  const getDevices = () => {
    deviceMineApi(token)
      .then((res) => {
        // console.log(res);
        dispatch(setDeviceMine(res.data.data));
        ProfileShowHideFunc("deviceMine");
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
          setShowAlert((prevState) => ({
            ...prevState,
            show: true,
            message: t("خطایی رخ داده است . لطفا مجددا امتحان کنید."),
            type: "Error",
          }));
          setTimeout(() => {
            setShowAlert((prevState) => ({
              ...prevState,
              show: false,
            }));
          }, 2000);
        }
      });
  };

  const dashboardDetail = (value, index) => {
    setActiveIndex(index);
    const formData = new FormData();
    formData.append("dashboard", value.id);
    dashboardZone(formData, token)
      .then((res) => {
        dispatch(setDashboardDetails(value));
        dispatch(setDashboardZone(res.data.data));
        const zoneId = new FormData();
        zoneId.append("zone", res.data.data[0]["id"]);
        zoneWidgets(zoneId, token)
          .then((res) => {
            dispatch(setZoneWidgets(res.data.data));
          })
          .catch(() => {
            dispatch(setZoneWidgets([]));
          });
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
          setShowAlert((prevState) => ({
            ...prevState,
            show: true,
            message: t("خطایی رخ داده است . لطفا مجددا امتحان کنید."),
            type: "Error",
          }));
          setTimeout(() => {
            setShowAlert((prevState) => ({
              ...prevState,
              show: false,
            }));
          }, 2000);
        }
      });
  };

  const deleteDashboard = async (id) => {
    let countDevice = 0;
    var myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    try {
      var formdata = new FormData();
      formdata.append("dashboard", id);
      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      let response = await fetch(
        "https://assessn.mmaviot.com/api/dashboard_zones",
        requestOptions
      );
      let result = await response.json();

      for (const zone of result.data) {
        let formdataZone = new FormData();
        formdataZone.append("zone", zone.id);
        let requestOptionsZone = {
          method: "POST",
          headers: myHeaders,
          body: formdataZone,
          redirect: "follow",
        };

        let responseZone = await fetch(
          "https://assessn.mmaviot.com/api/zone_widgets",
          requestOptionsZone
        );
        let resultZone = await responseZone.json();

        if (resultZone.data.length !== 0) {
          countDevice++;
        }
      }

      if (countDevice === 0) {
        setShowAlert((prevState) => ({
          ...prevState,
          show: true,
          message: t("آیا از حذف این ساختمان اطمینان دارید؟"),
          type: "Warning",
          question: true,
          id: id,
          request: "dashboard",
        }));

        setTimeout(() => {
          setShowAlert((prevState) => ({ ...prevState, show: false }));
        }, 10000);
      } else {
        setShowAlert((prevState) => ({
          ...prevState,
          show: true,
          message: t(
            "این ساختمان حاوی دستگاه است! ابتدا دستگاه مربوطه حذف گردد."
          ),
          type: "Warning",
          question: false,
        }));

        setTimeout(() => {
          setShowAlert((prevState) => ({ ...prevState, show: false }));
        }, 10000);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  return (
    <>
      {!showHomeEdit ? (
        <div style={{ padding: "32px 24px", minHeight: "90vh" }}>
          {/* Profile Header */}
          <div style={{ textAlign: "center", marginBottom: "32px" }}>
            <div
              style={{
                width: "100px",
                height: "100px",
                borderRadius: "50%",
                overflow: "hidden",
                border: "4px solid var(--primary-color)",
                boxShadow: "0 4px 12px rgba(102, 126, 234, 0.3)",
                margin: "0 auto 20px",
              }}
            >
              <img
                src={
                  userInfo.image !== ""
                    ? "https://assessn.mmaviot.com" + userInfo.image
                    : avatar
                }
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            </div>
            <h2 style={{ fontSize: "22px", fontWeight: "700", color: "var(--text-primary)", margin: "0 0 4px 0" }}>
              {userInfo.name}
            </h2>
            <p style={{ fontSize: "14px", color: "var(--text-secondary)", margin: 0 }}>
              {userInfo.email}
            </p>
          </div>

          {/* Dashboard and Devices Section */}
          <div style={{ marginBottom: "32px" }}>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", marginBottom: "24px" }}>
              {/* Dashboards Card */}
              <div
                onClick={() => setShowDashboard(!showDashboard)}
                style={{
                  padding: "16px",
                  background: "var(--bg-card)",
                  border: "1px solid var(--border-color)",
                  borderRadius: "12px",
                  cursor: "pointer",
                  transition: "var(--transition)",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "8px",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow = "var(--shadow-md)";
                  e.currentTarget.style.borderColor = "var(--primary-color)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = "none";
                  e.currentTarget.style.borderColor = "var(--border-color)";
                }}
              >
                <div
                  style={{
                    width: "48px",
                    height: "48px",
                    borderRadius: "12px",
                    background: "linear-gradient(135deg, rgba(102, 126, 234, 0.2), rgba(118, 75, 162, 0.2))",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "var(--primary-color)",
                    fontSize: "24px",
                  }}
                >
                  <FiHome size={24} />
                </div>
                <p style={{ fontSize: "13px", fontWeight: "600", color: "var(--text-primary)", margin: "0" }}>
                  {t("خانه")}
                </p>
                <p style={{ fontSize: "12px", color: "var(--text-secondary)", margin: "0" }}>
                  {userInfo.dashboard_count} {t("عدد")}
                </p>
              </div>

              {/* Devices Card */}
              <div
                onClick={getDevices}
                style={{
                  padding: "16px",
                  background: "var(--bg-card)",
                  border: "1px solid var(--border-color)",
                  borderRadius: "12px",
                  cursor: "pointer",
                  transition: "var(--transition)",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "8px",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow = "var(--shadow-md)";
                  e.currentTarget.style.borderColor = "var(--primary-color)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = "none";
                  e.currentTarget.style.borderColor = "var(--border-color)";
                }}
              >
                <div
                  style={{
                    width: "48px",
                    height: "48px",
                    borderRadius: "12px",
                    background: "linear-gradient(135deg, rgba(102, 126, 234, 0.2), rgba(118, 75, 162, 0.2))",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "var(--primary-color)",
                    fontSize: "24px",
                  }}
                >
                  <FiCpu size={24} />
                </div>
                <p style={{ fontSize: "13px", fontWeight: "600", color: "var(--text-primary)", margin: "0" }}>
                  {t("دستگاه")}
                </p>
                <p style={{ fontSize: "12px", color: "var(--text-secondary)", margin: "0" }}>
                  {deviceMine.length} {t("عدد")}
                </p>
              </div>
            </div>

            {/* Dashboard List */}
            {showDashboard && (
              <div style={{ marginBottom: "24px" }}>
                <p style={{ fontSize: "12px", fontWeight: "600", color: "var(--text-secondary)", marginBottom: "12px", margin: "0 0 12px 0" }}>
                  {t("لیست خانه ها")}
                </p>
                <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                  {dashboardMine?.map((dash, index) => {
                    const active = activeIndex === index ? true : false;
                    return (
                      <div
                        key={index}
                        onClick={() => dashboardDetail(dash, index)}
                        style={{
                          padding: "12px 16px",
                          background: active ? "var(--primary-gradient)" : "var(--bg-card)",
                          color: active ? "#fff" : "var(--text-primary)",
                          border: `1px solid ${active ? "var(--primary-color)" : "var(--border-color)"}`,
                          borderRadius: "12px",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          transition: "var(--transition)",
                        }}
                        onMouseEnter={(e) => {
                          if (!active) {
                            e.currentTarget.style.borderColor = "var(--primary-color)";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (!active) {
                            e.currentTarget.style.borderColor = "var(--border-color)";
                          }
                        }}
                      >
                        <FiTrash2
                          size={16}
                          onClick={(e) => {
                            e.stopPropagation();
                            deleteDashboard(dash.id);
                          }}
                          style={{ cursor: "pointer", opacity: 0.7 }}
                        />
                        <span style={{ fontSize: "14px", fontWeight: "500" }}>
                          {dash.dashboard_caption}
                        </span>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>

          {/* Settings Section */}
          <div style={{ marginBottom: "32px" }}>
            <p style={{ fontSize: "12px", fontWeight: "600", color: "var(--text-secondary)", margin: "0 0 12px 0" }}>
              {t("تنظیمات")}
            </p>
            <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
              <button
                onClick={() => ProfileShowHideFunc("settingPage")}
                style={{
                  padding: "14px 16px",
                  background: "var(--bg-card)",
                  border: "1px solid var(--border-color)",
                  borderRadius: "12px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  transition: "var(--transition)",
                  color: "var(--text-primary)",
                  fontSize: "14px",
                  fontWeight: "500",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow = "var(--shadow-sm)";
                  e.currentTarget.style.borderColor = "var(--primary-color)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = "none";
                  e.currentTarget.style.borderColor = "var(--border-color)";
                }}
              >
                <FiChevronDown size={18} />
                <span style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <FiEdit2 size={16} />
                  {t("ویرایش اطلاعات")}
                </span>
              </button>
              <button
                onClick={() => ProfileShowHideFunc("setting")}
                style={{
                  padding: "14px 16px",
                  background: "var(--bg-card)",
                  border: "1px solid var(--border-color)",
                  borderRadius: "12px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  transition: "var(--transition)",
                  color: "var(--text-primary)",
                  fontSize: "14px",
                  fontWeight: "500",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow = "var(--shadow-sm)";
                  e.currentTarget.style.borderColor = "var(--primary-color)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = "none";
                  e.currentTarget.style.borderColor = "var(--border-color)";
                }}
              >
                <FiChevronDown size={18} />
                <span style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <FiSettings size={16} />
                  {t("تنظیمات")}
                </span>
              </button>
            </div>
          </div>

          {/* Users Section */}
          <div>
            <p style={{ fontSize: "12px", fontWeight: "600", color: "var(--text-secondary)", margin: "0 0 12px 0" }}>
              {t("کاربران")}
            </p>
            <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginBottom: "24px" }}>
              {invitationList?.map((user, index) => (
                <Users key={index} user={user} />
              ))}
            </div>

            {/* Add User Button */}
            <button
              onClick={() => setOpenAddUser(!openAddUser)}
              style={{
                width: "100%",
                padding: "14px 16px",
                background: "var(--primary-gradient)",
                color: "#fff",
                border: "none",
                borderRadius: "12px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                fontSize: "14px",
                fontWeight: "600",
                transition: "var(--transition)",
                boxShadow: "var(--shadow-md)",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow = "var(--shadow-lg)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "var(--shadow-md)";
              }}
            >
              <FiPlus size={18} />
              {t("افزودن کاربر")}
            </button>
          </div>

          {/* Add User Form */}
          {openAddUser && (
            <div style={{ marginTop: "24px", padding: "20px", background: "var(--bg-light)", borderRadius: "12px" }}>
              <p style={{ fontSize: "14px", fontWeight: "600", color: "var(--text-primary)", marginBottom: "16px" }}>
                {t("افزودن کاربر جدید")}
              </p>

              <Formik
                initialValues={initialValues}
                onSubmit={submitForm}
                validationSchema={validationSchema}
              >
                {(formProps) => (
                  <Form ref={form}>
                    <div style={{ marginBottom: "16px" }}>
                      <input
                        type="text"
                        name="name"
                        placeholder={t("نام کاربر")}
                        onChange={formProps.handleChange}
                        onBlur={formProps.handleBlur}
                        className="form-control"
                      />
                      <ErrorMessage name="name">
                        {(errMsg) => (
                          <div style={{ fontSize: "12px", color: "#f56565", marginTop: "6px" }}>
                            {errMsg}
                          </div>
                        )}
                      </ErrorMessage>
                    </div>
                    <div style={{ marginBottom: "16px" }}>
                      <input
                        type="email"
                        placeholder={t("ایمیل کاربر")}
                        name="email"
                        className="form-control"
                        onChange={formProps.handleChange}
                        onBlur={formProps.handleBlur}
                      />
                      <ErrorMessage name="email">
                        {(errMsg) => (
                          <div style={{ fontSize: "12px", color: "#f56565", marginTop: "6px" }}>
                            {errMsg}
                          </div>
                        )}
                      </ErrorMessage>
                    </div>
                    <button
                      type="submit"
                      className="btn btn-primary"
                      style={{ width: "100%", fontSize: "14px" }}
                    >
                      <FiPlus size={16} />
                      {t("تائید")}
                    </button>
                  </Form>
                )}
              </Formik>
            </div>
          )}
        </div>
      ) : (
        <HomeEdit />
      )}

      {showAlert.show && (
        <Alert
          message={showAlert.message}
          type={showAlert.type}
          question={showAlert.question}
          id={showAlert.id}
          request={showAlert.request}
          toggleAlert={toggleAlert}
        />
      )}
    </>
  );
};

const ProfileFirstPage = withRouter(ProfileFirstPageComp);

export { ProfileFirstPage };
